module.exports = __webpack_public_path__ + "img/QLG19-215&C215@2x-1793698374569.png";